import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsComponentCarousel } from './cms-component-carousel.interface';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../catalog/config/component.config';

export const CMS_COMPONENT_CAROUSEL_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentCarousel.ID,
    isAdvanced: true,
    name: 'Carousel',
    description: 'Carousel with slides',
    tags: ['banner', 'image', 'carousel'],
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        {
            key: 'autoplay',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Autoplay',
            default: false,
            canShow: (data: NCmsComponentCarousel.IData) => data?.slides?.length > 1
        },
        {
            key: 'interval',
            type: NICmsContentField.EFieldType.number,
            title: 'Interval',
            canShow: (data: NCmsComponentCarousel.IData) => !!data?.autoplay && data?.slides?.length > 1,
            default: 5000
        },
        {
            key: 'loop',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Loop',
            default: false,
            canShow: (data: NCmsComponentCarousel.IData) => data?.slides?.length > 1
        },
        {
            key: 'pagination',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show Bullet Controllers',
            default: true,
            canShow: (data: NCmsComponentCarousel.IData) => data?.slides?.length > 1
        },
        {
            key: 'arrows',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show Navigate Arrows',
            default: true,
            canShow: (data: NCmsComponentCarousel.IData) => data?.slides?.length > 1
        },
        {
            key: 'progress',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Show Progress Bar',
            default: true,
            canShow: (data: NCmsComponentCarousel.IData) => data?.slides?.length > 1
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1'
        },
        // slides
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'slides',
            title: 'Slides',
            itemName: 'Slide',
            fields: [
                {
                    key: 'custom',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Custom Content',
                    default: false
                },
                {
                    key: 'image',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image',
                    default: '',
                    canShow: (data: NCmsComponentCarousel.ISlide) => !data?.custom,
                    required: true
                },
                <NICmsContentField.IComponentsField>{
                    type: NICmsContentField.EFieldType.components,
                    title: 'Components',
                    itemName: 'component',
                    key: 'components',
                    default: [],
                    canShow: (data: NCmsComponentCarousel.ISlide) => data?.custom
                },
                ...CMS_COMPONENT_CWV_CONFIG
            ],
            defaultSize: 2
        }
    ]
};
